import React from 'react';
import CurvePanel from './CurvePanel';
import { useSelector } from 'react-redux';
import NewNode from './NewNode';
import AddChildrenNode from './AddChildrenNode';
import EditNode from './EditNode';
import NodePanel from './NodePanel';
import EditAggregator from './EditAggregator';
import AggregatorPanel from './AggregatorPanel';
import NewAggregator from './NewAggregator';
import NewDevice from './NewDevice';
import AddChildrenDevice from './AddChildrenDevice';
import EditDevice from './EditDevice';
import DevicePanel from './DevicePanel';
import NewControl from './NewControl';
import EditNodeDefaultControl from './EditNodeDefaultControl';
import ControlPanel from './ControlPanel';
import CancelControl from './CancelControl';
import NewCurve from './NewCurve';
import AddExistingCurve from './AddExistingCurve';
import { RESOURCE_TYPES } from 'utils/appConstants';
import MeterPanel from './MeterPanel';

const entityStateRenderList = {
  [RESOURCE_TYPES.TOPONODE]: {
    create: NewNode,
    addExisting: AddChildrenNode,
    update: EditNode,
    read: NodePanel
  },
  [RESOURCE_TYPES.INDENODE]: {
    create: NewNode,
    update: EditNode,
    read: NodePanel
  },
  [RESOURCE_TYPES.AGGREGATOR]: {
    create: NewAggregator,
    update: EditAggregator,
    read: AggregatorPanel
  },
  [RESOURCE_TYPES.DEVICE]: {
    create: NewDevice,
    addExisting: AddChildrenDevice,
    update: EditDevice,
    read: DevicePanel
  },
  [RESOURCE_TYPES.METER]: {
    read: MeterPanel
  },
  [RESOURCE_TYPES.CONTROL]: {
    create: NewControl,
    update: EditNodeDefaultControl,
    read: ControlPanel,
    delete: CancelControl
  },
  [RESOURCE_TYPES.CURVE]: {
    create: NewCurve,
    addExisting: AddExistingCurve,
    read: CurvePanel
  }
};

const SidePanel = () => {
  const sidePanel = useSelector(state => state.sidePanel);

  const decidePanelRenders = () => {
    const { id, entity, state, breadcrumbs } = sidePanel;

    const allPanelsOpen = breadcrumbs.concat([{ id, entity, state }]);

    const displayPanels = allPanelsOpen.map((panel, index) => {
      const key = JSON.stringify({
        entity: panel.entity,
        state: panel.state,
        id: panel.id
      });
      const ComponentName = entityStateRenderList[panel.entity][panel.state];
      return (
        <ComponentName
          key={key}
          isActive={index === allPanelsOpen.length - 1 ? true : false}
        />
      );
    });
    return <>{displayPanels}</>;
  };
  const { displaySidePanel } = sidePanel;
  return <>{displaySidePanel ? decidePanelRenders() : null}</>;
};

export default SidePanel;
